module.exports = __webpack_public_path__ + "img/027-sailboat.05f38aa1.svg";